import React from 'react';
import { Sheet, UseSheetReturnType } from '../../../../mobile/structural/sheet';
import { useTranslator } from '../../../i18n/useTranslator';
import BoardLinkSheetContent from './BoardLinkSheetContent';

type BoardLinkSheetProps = {
    sheetProps: UseSheetReturnType;
};

const BoardLinkSheet: React.FC<BoardLinkSheetProps> = ({ sheetProps }) => {
    const translate = useTranslator('toolbar', 'tools.editing.insertMenu');

    return (
        <Sheet className="MobileInsertBoardLinkSheet" {...sheetProps} defaultSnapPoint={0.5} snapPoints={[0.5, 1]}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Header>
                    <Sheet.Heading>{translate('boardLink')}</Sheet.Heading>
                    <Sheet.DoneButton />
                </Sheet.Header>
                <BoardLinkSheetContent />
            </Sheet.Panel>
        </Sheet>
    );
};

export default BoardLinkSheet;
